import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { urls } from 'src/services/api/urls';
import * as servers from '../../../services/api/servers';
import { GeneralServicesImplService } from 'src/services/general-services-impl.service';
import { Observable } from 'rxjs';
import { ProjectConstants } from 'src/app/project-constants';

@Injectable({
  providedIn: 'root'
})
export class LocationService extends GeneralServicesImplService {

  constructor(http: HttpClient) {
    super(http);
  }

  // baseUrl: string = servers.apiUrl + urls.cobidbService + urls.resourceUnits;
  baseUrl: string = servers.apiUrl + urls.deltaVolumi;

  getPageInAllSettings(filter: any, offset?: any): Observable<any> {
    const url = this.baseUrl + this.LINKS.PAGE_IN_ALL_SETTING;
    const body =  offset ? JSON.stringify(offset) : null;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'json', params: filter})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }
}
